import { exists } from 'helpers/exists'
import { useTranslation } from 'helpers/hooks/useTranslation'
import React, { FC, useMemo } from 'react'
import { useService } from 'services/utils/context'
import ProductTileCTAContext, {
  ProductTileCTAContextValue,
} from 'sharedComponents/ProductTileConnected/ProductTileCTAContext'

interface Props {
  onCTAClick: (productId?: number) => void
}

const ProductTileCTAToBasket: FC<React.PropsWithChildren<Props>> = ({
  children,
  onCTAClick,
}) => {
  const { t } = useTranslation()
  const service = useService()

  const ctaContextValue = useMemo<ProductTileCTAContextValue>(
    () => ({
      showButton: id => {
        const item = service.products.getById(id)
        return exists(item) && item.isActive
      },
      createButtonLabel: () => t('Hinzufügen'),
      onButtonClick: id => {
        if (onCTAClick) {
          onCTAClick(Number(id))
        }
      },
    }),
    [service, onCTAClick, t],
  )

  return (
    <ProductTileCTAContext.Provider value={ctaContextValue}>
      {children}
    </ProductTileCTAContext.Provider>
  )
}

export default ProductTileCTAToBasket
